import { useMemo } from 'react';
import { type IAuthors } from '@/types/INote';
import styles from './index.module.scss';

export default function NoteAuthor ({ authors }: { authors: IAuthors[] }) {
  const authorsText = useMemo(() => authors.map((a) => a.name).join(', '), [authors]);
  return <div className={styles['note-authors']} data-e='note-author'>{authorsText}</div>;
}
